<div mat-dialog-title>
  Select & Assign Account(s) to this Portfolio
  @if (!isAltWorkflow) {
    <span class="stepsProgressIndicator">Step 2 of 4</span>
  }
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
  <div class="nameHeader">Portfolio: {{portfolioName}}</div>
  <div>Select from the accounts below. Once you assign them, they wil be removed from this list.</div>
  <div>@if (!isUiTest) {
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'350px'"
      [gridHeight] = "'350px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [footerContent] = "footerContent"
      [frameworkComponents] = 'frameworkComponents'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid>
  }</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  @if (totalSelectCount == 0) {
    <button id="assignButtonInactive" [disabled]="true" class="btn-medium-primary">Assign accounts to portfolio</button>
  }
  @if (totalSelectCount > 0) {
    <button id="assignButtonActive" (click)="callFinishButtonCallback()" class="btn-medium-primary">Assign {{totalSelectCount}} accounts to portfolio</button>
  }
</mat-dialog-actions>

